import { render, staticRenderFns } from "./PublicationsBySourceHeader.vue?vue&type=template&id=605ac372&"
import script from "./PublicationsBySourceHeader.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySourceHeader.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySourceHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports